export const GET_DATA_CHART_REDUCER = 'GET_DATA_CHART_REDUCER';
export const GET_DATA_CHART_REQUEST = 'GET_DATA_CHART_REQUEST';